import { Component, Input } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';
import { SeveritySelectFieldComponent } from '../fields/severity-select-field/severity-select-field.component';
import { StatusSelectFieldComponent } from '../fields/status-select-field/status-select-field.component';
import { SeverityValueEnum } from 'app/shared/enums/severity.enum';
import { CommonModule } from '@angular/common';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';

@Component({
  selector: 'app-ticket-info-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputFormFieldComponent,
    SeveritySelectFieldComponent,
    StatusSelectFieldComponent,
    DatepickerFormFieldComponent,
    TranslateModule,
    CommonModule,
  ],
  templateUrl: './ticket-info-form.component.html',
  styleUrl: './ticket-info-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class TicketInfoFormComponent {
  @Input() severityItems: any[] = [];
  @Input() statusItems: any[] = [];

  form: any;
  viewMode = true;

  constructor(
    public mainForm: FormGroupDirective,
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.mainForm.form;
    this.form.addControl('createdAt', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('verifyDate', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('caseClosedDate', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('initialResponseDate', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('caseStatus', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('severity', new FormControl(null, []));
    this.form.addControl('productSuite', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('productCompany', new FormControl({ value: null, disabled: true }, []));    
  }

  changeSeverity(data: any) {
    this.setNextActionDueDate(data.value);
  }

  setNextActionDueDate(severityValue: string) {
    switch (severityValue) {
      case SeverityValueEnum.S1_TOOL_DOWN:
        this.form.get('nextActionDueDate').setValue(this.setDate());
        break;
      case SeverityValueEnum.S1_SAFETY_ISSUE_PI:
        this.form.get('nextActionDueDate').setValue(this.setDate());
        break;
      case SeverityValueEnum.S2_HIGH_IMPACT_ISSUE:
        this.form.get('nextActionDueDate').setValue(this.setDate(1));
        break;
      case SeverityValueEnum.S3_MEDIUM_IMPACT_ISSUE:
        this.form.get('nextActionDueDate').setValue(this.setDate(1));
        break;
      case SeverityValueEnum.S4_LOW_IMPACT_ISSUE:
        this.form.get('nextActionDueDate').setValue(this.setDate(2));
        break;
      case SeverityValueEnum.S4_REQUEST_FOR_INFORMATION:
        this.form.get('nextActionDueDate').setValue(this.setDate(2));
        break;
    }

  }

  setDate(days?: number) {
    const newDate = new Date();
    if(days) {
      newDate.setDate(new Date().getDate() + days);
    }
    return newDate;
}

}
